/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
// Public API for compiler
export { COMPILER_OPTIONS, Compiler, CompilerFactory, ModuleWithComponentFactories } from "./linker/compiler";
export { ComponentFactory, ComponentRef } from "./linker/component_factory";
export { ComponentFactoryResolver } from "./linker/component_factory_resolver";
export { ElementRef } from "./linker/element_ref";
export { NgModuleFactory, NgModuleRef } from "./linker/ng_module_factory";
export { NgModuleFactoryLoader, getModuleFactory } from "./linker/ng_module_factory_loader";
export { QueryList } from "./linker/query_list";
export { SystemJsNgModuleLoader, SystemJsNgModuleLoaderConfig } from "./linker/system_js_ng_module_factory_loader";
export { TemplateRef } from "./linker/template_ref";
export { ViewContainerRef } from "./linker/view_container_ref";
export { EmbeddedViewRef, ViewRef } from "./linker/view_ref";
//# sourceMappingURL=linker.js.map


// WEBPACK FOOTER //
// ../../../packages/core/esm5/src/linker.js